export default __webpack_public_path__ + "static/media/altisbeyaz.94b58e1f.png";